import { captureException } from '@sentry/nextjs';

import { SDE } from './types';

export const getLiveEngageLocale = (locale = '') => locale.split('-')[0];

export const getSDEs = async (supportRequestId: string) => {
  const sdes: SDE[] = [];

  // Inline import since the auth lib only works in browsers
  const cbAuthToken = await (await import('utils/client/auth/auth')).getChatbotAuthToken();
  // Anonymous users won't have a chatbot token
  if (cbAuthToken) {
    sdes.push({
      type: 'ctmrinfo',
      info: { role: cbAuthToken },
    });
  }

  sdes.push({
    type: 'lead',
    lead: { topic: 'Contact us' }, // Legacy, unused, to be removed?
  });

  sdes.push({
    type: 'mrktInfo',
    info: {
      campaignId: supportRequestId,
    },
  });

  return sdes;
};

export const sendChatData = async (market: string, supportRequestId: string) => {
  const payload = {
    supportRequestId,
    // contact-history requires these fields to be set for now
    topic: 'Contact us',
    formType: 'simple',
  };

  try {
    const response = await fetch(`/api/web/${market}/contact-history/`, {
      method: 'POST',
      body: JSON.stringify(payload),
      headers: { 'content-type': 'application/json' },
    });

    if (!response.ok) {
      captureException(`Called ":api-web:/contact-history/", got: ${response.status}`);
    }
  } catch (e) {
    captureException(e);
  }
};
